import { createFileRoute, Link } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";

export const Route = createFileRoute("/admin/exams/$examId/subjects")({
  component: AdminSubjectsForExam,
});

function AdminSubjectsForExam() {
  const { examId } = Route.useParams();

  return (
    <div>
      <div className="label-card">
        <Link to="/admin/exams" className="hover:text-paprika">
          ← Exams
        </Link>
      </div>
      <div className="mt-2 flex items-end justify-between">
        <h1 className="font-display text-3xl font-semibold">
          Subjects for exam <span className="font-mono text-lg">{examId}</span>
        </h1>
        <button className="inline-flex items-center gap-2 rounded-md bg-paprika px-3 py-2 text-xs font-semibold uppercase tracking-widest text-white">
          <PlusIcon className="h-3.5 w-3.5" /> New subject
        </button>
      </div>

      <div className="mt-8 card-ledger p-8 text-center text-ink-soft">
        Subject CRUD table renders here once the backend endpoints are live.
        Wire to <code className="font-mono text-xs">/exams/{"{examId}"}/subjects</code>
        with admin token.
      </div>
    </div>
  );
}
